<!-- SubNavCard.vue -->
<template>
  <div class="">
    <div class="row d-table overflow-x-auto s-layout__index_header">
      <div class="btn-group w-auto" role="group">
        <button
          v-for="(button, index) in buttons"
          :key="index"
          type="button"
          @click="navigateToRoute(button.route)"
          class="btn w-auto"
          :class="{ 'active ': $route.name === button.route }"
        >
          <i :class="button.icon"></i>
          {{ button.label }}
        </button>
      </div>
    </div>
    <div class="mt-3">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    buttons: {
      type: Array,
      required: true,
    },
  },
  methods: {
    navigateToRoute(routeName) {
      // Only navigate if we're not already on this route
      if (this.$route.name !== routeName) {
        this.$router.push({ name: routeName }).catch((err) => {
          // Ignore navigation duplicated errors
          if (err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        });
      }
    },
  },
};
</script>
